import { z } from 'zod';

const geogebraDataSchema = z.object({
  ggbBase64: z.string(),
  aspectRatio: z.number(),
  flowType: z.enum(["investigating", "validated", "random"]),
  settings: z.object({
    enableRightClick: z.boolean().optional().default(false),
    enableShiftDragZoom: z.boolean().optional().default(false),
    enableLabelDrags: z.boolean().optional().default(false),
    showMenuBar: z.boolean().optional().default(false),
    showToolBar: z.boolean().optional().default(false),
    showResetIcon: z.boolean().optional().default(false),
    showAlgebraInput: z.boolean().optional().default(false),
    allowStyleBar: z.boolean().optional().default(false)
  }).optional().default({
    allowStyleBar: false,
    enableLabelDrags: false,
    enableRightClick: false,
    enableShiftDragZoom: false,
    showAlgebraInput: false,
    showMenuBar: false,
    showResetIcon: false,
    showToolBar: false
  })
});

export { geogebraDataSchema };
//# sourceMappingURL=geogebra.component-data.js.map
